import { render, staticRenderFns } from "./CancelAssignmentDialog.vue?vue&type=template&id=60d9f2c4&"
import script from "./CancelAssignmentDialog.vue?vue&type=script&lang=js&"
export * from "./CancelAssignmentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports